import { render } from "./unggahTes.vue?vue&type=template&id=fea7b8b2&scoped=true"
import script from "./unggahTes.vue?vue&type=script&lang=js"
export * from "./unggahTes.vue?vue&type=script&lang=js"

import "./unggahTes.vue?vue&type=style&index=0&id=fea7b8b2&scoped=true&lang=css"

import exportComponent from "/Users/mymac/Documents/Digitala/Pulih_Anita/frontend-pulih/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fea7b8b2"]])

export default __exports__